import { useQuery } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";

export const useRequestCategories = (type?: string) => {
  return useQuery({
    queryKey: ["requestCategories", type],
    queryFn: requestCategoryService.getRequestCategories,
    select: (data) => {
      if (type != null) {
        return data.filter((category) => category.chat_type === type);
      }
      return data;
    },
  });
};
